import { render, staticRenderFns } from "./BulkProjectCreatePage.vue?vue&type=template&id=f3568156&scoped=true&"
import script from "./BulkProjectCreatePage.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectCreatePage.vue?vue&type=style&index=0&id=f3568156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3568156",
  null
  
)

export default component.exports